import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", null, [
      (
          _ctx.piniaStore.state.ferienhaus.versicherungsumfang === '0001' ||
          _ctx.piniaStore.state.ferienhaus.versicherungsumfang === '0002'
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.vgv_runterladen && _ctx.vgv_runterladen(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.getAntragOderVorschlag()) + " Wohngebäudeversicherung als PDF herunterladen", 1)
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.piniaStore.state.ferienhaus.versicherungsumfang === '0001' ||
          _ctx.piniaStore.state.ferienhaus.versicherungsumfang === '0003'
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.vhv_runterladen && _ctx.vhv_runterladen(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.getAntragOderVorschlag()) + " Hausratversicherung als PDF herunterladen", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.tarifinformationen.hausundgrundbesitzerhaftpflicht)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hug_runterladen && _ctx.hug_runterladen(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.getAntragOderVorschlag()) + " Haus- und Grundbesitzerhaftpflicht als PDF herunterladen", 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}